<template>
  <div>
    <!-- Điều kiện hiển thị nút Trình duyệt, còn thiếu author -->
    <template
      v-if="
        !form.approvalStatus ||
          form.approvalStatus === 'Editting' ||
          form.approvalStatus === 'Draft'
      "
    >
      <TrinhDuyetBtn :form="form" />
    </template>
    <!-- ĐK hiển thị nút Phê duyệt -->
    <template v-else-if="form.approvalStatus === 'Pending'">
      <PheDuyetBtn :form="form" />
    </template>
  </div>
</template>
<script>
import TrinhDuyetBtn from "./TrinhDuyetBtn";
import PheDuyetBtn from "./PheDuyetBtn";
export default {
  components: { TrinhDuyetBtn, PheDuyetBtn },
  props: {
    form: {
      type: Object,
      required: true
    }
  }
};
</script>
